import { createReducer, on } from '@ngrx/store';
import { Webshop } from '@models/webshop.model';
import {
  cannotCreateWebshop,
  cannotFetchWebshop,
  cannotFetchWebshops,
  cannotUpdateWebshop,
  createWebshop,
  deleteWebshop,
  fetchWebshop,
  fetchWebshops,
  selectWebshop,
  updateWebshop,
  webshopCreated,
  webshopDeleted,
  webshopFetched,
  webshopsFetched,
  webshopUpdated
} from '../actions/webshop.actions';
import { SharedState } from './index';

export interface WebshopState extends SharedState {
  webshops: Webshop[];
  detail: Webshop;
  selectedWebshopId: string | null;
}

export const initialWebshopState: WebshopState = {
  loaded: false,
  isLoading: false,
  error: '',
  webshops: [],
  detail: {
    id: '',
    companyId: '',
    name: '',
    chamberOfCommerce: 0,
    creationDate: ''
  },
  selectedWebshopId: null
}

export const webshopReducer = createReducer(
  initialWebshopState,
  on(fetchWebshops, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(webshopsFetched, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    webshops: payload,
    selectedWebshopId: payload.length === 1 ? (payload[0].id ?? null) : state.selectedWebshopId
  })),
  on(cannotFetchWebshops, (state, {error}) => ({...state, isLoading: false, loaded: false, error, webshops: []})),
  // Get single
  on(fetchWebshop, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(webshopFetched, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    detail: payload
  })),
  on(cannotFetchWebshop, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  // Create
  on(createWebshop, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(webshopCreated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    webshops: [...state.webshops, payload]
  })),
  on(cannotCreateWebshop, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  // Update
  on(updateWebshop, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(webshopUpdated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    webshops: state.webshops.map(w => w.id && payload.id && w.id === payload.id ? payload : w)
  })),
  on(cannotUpdateWebshop, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  // Delete
  on(deleteWebshop, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(webshopDeleted, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    webshops: state.webshops.filter(w => w.id !== payload)
  })),
  on(selectWebshop, (state, {payload}) => ({...state, selectedWebshopId: payload})),
);
